import React, { PropsWithChildren } from 'react';
import ButtonBase from './ButtonBase';

interface ButtonProps {
  onClick: CallableFunction;
  disabled?: boolean;
  rounded?: boolean;
  className?: string;
  outline?: boolean;
  gray?: boolean;
  withLoading?: boolean;
  type?: 'button' | 'submit' | 'reset' | undefined;
}

const Button = ({
  children,
  onClick = () => {},
  disabled = false,
  rounded = false,
  className,
  outline = false,
  gray = false,
  type = 'button',
  withLoading

}: PropsWithChildren<ButtonProps>) => {

  const handleClick = () => {
    onClick()
  }

  return (
    <ButtonBase
      type={type}
      onClick={handleClick}
      disabled={disabled}
      rounded={rounded}
      withLoading={withLoading}
      className={`
        ${className}
        ${gray ? 'bg-gray-50 ring-transparent' : ''}
        ${outline ? 'ring-gray-400 hover:ring-gray-300' : 'ring-gray-300 hover:ring-gray-400 hover:bg-gray-50 '}
    `}>
      {children}
    </ButtonBase>
  )
}

export default Button;